var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.list.isEdit)?_c('a-input',{attrs:{"defaultValue":_vm.list[_vm.itemKey],"size":"small"},on:{"change":_vm.handleChange}}):[_vm._v(_vm._s(_vm.list[_vm.itemKey]))]],2)}
var staticRenderFns = []

export { render, staticRenderFns }